import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import useAuthStore from '../store/useAuthStore';

const GCC_COUNTRIES = [
  { code: 'KW', label: 'Kuwait' },
  { code: 'AE', label: 'UAE' },
  { code: 'SA', label: 'KSA' },
  { code: 'QA', label: 'Qatar' },
  { code: 'BH', label: 'Bahrain' },
  { code: 'OM', label: 'Oman' },
];

export default function SplashPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const [countries, setCountries] = useState(GCC_COUNTRIES);

  useEffect(() => {
    if (isAuthenticated) navigate('/home', { replace: true });
  }, [isAuthenticated, navigate]);

  // Detect user's country and put it first
  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then(r => r.json())
      .then(data => {
        const userCode = data.country_code;
        const match = GCC_COUNTRIES.find(c => c.code === userCode);
        if (match) {
          setCountries([match, ...GCC_COUNTRIES.filter(c => c.code !== userCode)]);
        }
      })
      .catch(() => {}); // silently fall back to default order
  }, []);

  return (
    <div className="min-h-screen bg-dark-bg flex flex-col">
      {/* Hero section */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        {/* Glow orb */}
        <div
          className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-72 h-72 rounded-full opacity-20 blur-3xl"
          style={{ background: 'radial-gradient(circle, #6C5CE7, transparent)' }}
        />

        <div className="relative z-10 flex flex-col items-center gap-6">
          <img src="/logo-dark.png" alt="findr" style={{ height: 100, width: 'auto', objectFit: 'contain' }} />

          <p className="text-dark-subtext text-base max-w-xs">
            The GCC's creative marketplace. Hire talent, book studios, get things done.
          </p>

          {/* Feature pills */}
          <div className="flex flex-wrap justify-center gap-2 mt-2">
            {['🎨 Design', '🎬 Video', '📱 Marketing', '🎙️ Studios', '💻 Web Dev', '✍️ Content'].map(f => (
              <span key={f} className="text-xs px-3 py-1.5 rounded-full bg-dark-surface border border-dark-border text-dark-subtext">
                {f}
              </span>
            ))}
          </div>

          {/* CTA buttons */}
          <div className="flex flex-col gap-3 w-full max-w-xs mt-4">
            <button
              onClick={() => navigate('/onboarding')}
              className="w-full py-4 rounded-2xl bg-brand-gradient text-white font-semibold text-base tracking-wide glow"
            >
              Get Started
            </button>
            <button
              onClick={() => navigate('/auth')}
              className="w-full py-4 rounded-2xl bg-dark-surface border border-dark-border text-dark-text font-semibold text-base"
            >
              Sign In
            </button>
          </div>
        </div>
      </div>

      {/* Bottom bar — country order based on user location */}
      <div className="pb-8 text-center">
        <p className="text-dark-subtext text-xs">
          Available in {countries.map((c, i) => (
            <span key={c.code}>
              <span className={i === 0 ? 'text-brand-purple font-semibold' : ''}>{c.label}</span>
              {i < countries.length - 1 && ' · '}
            </span>
          ))}
        </p>
      </div>
    </div>
  );
}
